import React, {useEffect, useState} from "react";
import ReadyTimesLine from "./components/ReadyTimesLine";
import OperatorTimesPie from "./components/OperatorTimesPie";
import AllCallsStat from "./components/AllCallsStat";
import LeadsStatByDays from "./components/LeadsStatByDays";
import LeadsStatByHours from "./components/LeadsStatByHours";
import LeadsStatByWeekDays from "./components/LeadsStatByWeekDays";
import {apiConfig} from "../../../../config";
import axios from "axios";
import AoStatByDays from "./components/AoStatByDays";
import AoStatByWeekDays from "./components/AoStatByWeekDays";
import AoStatByHours from "./components/AoStatByHours";


const Dashboard = (props: any) => {
  const [selectedLeadStat, setSelectedLeadStat] = useState(0)
  const [selectedAoStat, setSelectedAoStat] = useState(0)

  const [usersData, setUsersData] = useState([])
  const [projectsData, setProjectsData] = useState([])

  const getUsers = async () => {
    const config = {
      method: 'get',
      url: `${apiConfig.url}/auth/list`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token_caltatToki')}`
      }
    };
    try {
      let response = await axios(config);

      setUsersData(response.data)
    } catch (error) {
      return {
        data: []
      }
      console.error('error', error);
    }
  }
  const getProjects = async () => {
    const config = {
      method: 'get',
      url: `${apiConfig.url}/project/list`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token_caltatToki')}`
      }
    };
    try {
      let response = await axios(config);

      setProjectsData(response.data)
    } catch (error) {
      console.error('error', error);
      return {
        data: []
      }
    }
  }

  useEffect(() => {
    getUsers()
    getProjects()
  }, [])

  return (
    <div style={{
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      overflow: 'scroll',
      paddingLeft: 40,
      paddingRight: 40,
      paddingBottom: 40,
    }}>
      <div style={{marginTop: 40}}>
        <div style={{textAlign: 'center', fontSize: 26, fontWeight: 'bold'}}>Лиды</div>
        <div style={{
          marginTop: 20,
          marginBottom: 20,
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          borderWidth: 1,
          borderLeftWidth: 0,
        }}>
          <div style={{
            padding: 10,
            alignItems: 'center',
            justifyContent: 'center',
            borderLeftWidth: 1,
            backgroundColor: selectedLeadStat === 0 ? 'white' : 'transparent',
            flex: 1,
            display: 'flex'
          }} onClick={() => {
            setSelectedLeadStat(0)
          }}>По дням
          </div>
          <div style={{
            padding: 10,
            alignItems: 'center',
            justifyContent: 'center',
            borderLeftWidth: 1,
            backgroundColor: selectedLeadStat === 1 ? 'white' : 'transparent',
            flex: 1,
            display: 'flex'
          }} onClick={() => {
            setSelectedLeadStat(1)
          }}>По дням недели
          </div>
          <div style={{
            padding: 10,
            alignItems: 'center',
            justifyContent: 'center',
            borderLeftWidth: 1,
            backgroundColor: selectedLeadStat === 2 ? 'white' : 'transparent',
            flex: 1,
            display: 'flex'
          }} onClick={() => {
            setSelectedLeadStat(2)
          }}>По часам
          </div>
        </div>
        <div style={{display: 'flex'}}>
          {selectedLeadStat === 0 && usersData.length > 0 && projectsData.length > 0 &&
              <LeadsStatByDays projectsData={projectsData} usersData={usersData}/>}
          {selectedLeadStat === 1 && usersData.length > 0 && projectsData.length > 0 &&
              <LeadsStatByWeekDays projectsData={projectsData} usersData={usersData}/>}
          {selectedLeadStat === 2 && usersData.length > 0 && projectsData.length > 0 &&
              <LeadsStatByHours projectsData={projectsData} usersData={usersData}/>}
        </div>
      </div>
      <div style={{display: 'flex', flexDirection: 'row', borderColor: 'black', marginTop: 40, marginBottom: 20}}>
        {/*<div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>*/}
        {/*  <div style={{textAlign: 'center', fontSize: 26, fontWeight: 'bold'}}>Загруженность операторов</div>*/}
        {/*  <OperatorTimesPie/>*/}
        {/*</div>*/}
        <div style={{display: 'flex', flex: 2, flexDirection: 'column'}}>
          <div style={{textAlign: 'center', fontSize: 26, fontWeight: 'bold'}}>Автоответчики</div>
          <div style={{
            marginTop: 20,
            marginBottom: 20,
            display: 'flex',
            flex: 1,
            flexDirection: 'row',
            borderWidth: 1,
            borderLeftWidth: 0,
          }}>
            <div style={{
              padding: 10,
              alignItems: 'center',
              justifyContent: 'center',
              borderLeftWidth: 1,
              backgroundColor: selectedAoStat === 0 ? 'white' : 'transparent',
              flex: 1,
              display: 'flex'
            }} onClick={() => {
              setSelectedAoStat(0)
            }}>По дням
            </div>
            <div style={{
              padding: 10,
              alignItems: 'center',
              justifyContent: 'center',
              borderLeftWidth: 1,
              backgroundColor: selectedAoStat === 1 ? 'white' : 'transparent',
              flex: 1,
              display: 'flex'
            }} onClick={() => {
              setSelectedAoStat(1)
            }}>По дням недели
            </div>
            <div style={{
              padding: 10,
              alignItems: 'center',
              justifyContent: 'center',
              borderLeftWidth: 1,
              backgroundColor: selectedAoStat === 2 ? 'white' : 'transparent',
              flex: 1,
              display: 'flex'
            }} onClick={() => {
              setSelectedAoStat(2)
            }}>По часам
            </div>
          </div>
          <div style={{display: 'flex'}}>
            {selectedAoStat === 0 && usersData.length > 0 && projectsData.length > 0 &&
                <AoStatByDays projectsData={projectsData} usersData={usersData}/>}
            {selectedAoStat === 1 && usersData.length > 0 && projectsData.length > 0 &&
                <AoStatByWeekDays projectsData={projectsData} usersData={usersData}/>}
            {selectedAoStat === 2 && usersData.length > 0 && projectsData.length > 0 &&
                <AoStatByHours projectsData={projectsData} usersData={usersData}/>}
          </div>
        </div>
      </div>
      <div style={{textAlign: 'center', fontSize: 26, fontWeight: 'bold', marginTop: 40}}>Звонки</div>
      <div style={{display: 'flex', flexDirection: 'column'}}>
        {usersData.length > 0 && projectsData.length > 0 &&
            <AllCallsStat projectsData={projectsData} usersData={usersData}/>}
      </div>
    </div>
  )
}

export default Dashboard
